import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
    maxW:{
        large:{
            large:'100px'
        }
    }
});
export default  theme;